import React from 'react';
import * as Yup from 'yup';
import {
  Box,
  Button,
  Card,
  CardContent,
  TextField,
  makeStyles,
  Grid,
  FormControl
} from '@material-ui/core';
import { Form, Formik } from 'formik';
import {
  useHistory,
  useLocation
} from 'react-router-dom';
import SelectField from '../../shared/SelectField';
import {getDataSelected} from 'src/helpers/random';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const useStyles = makeStyles((theme) => ({
  root: {
  },
  importButton: {
    marginRight: theme.spacing(1),
  },
  exportButton: {
    marginRight: theme.spacing(1)
  }
}));

const BarraBusquedaHeaders = ({ className, ...props }) => {
  const classes = useStyles();
  const query = useQuery();
  const history = useHistory();

  const getEstadoOptions = () => {
    return [{value: "", label: "Seleccione un estado..."}, {value: 1, label: "Activo"}, {value: 0, label: "Inactivo"}];
  };

  return (
    <Box mt={3}>
      <Card color="#eeeeee">
        <CardContent>
          <Formik
            initialValues={{
              name: query.get('name_filter') ? query.get('name_filter') : '',
              order: query.get('order_filter') ? query.get('order_filter') : '',
              active: query.get('active_filter') ? getDataSelected(getEstadoOptions(), 'value', query.get('active_filter'), 'label') : ''
            }}
            validationSchema={Yup.object().shape({
              name: Yup.string().max(255, 'El nombre no debe superar los 255 caracteres'),
              order: Yup.number(),
              active: Yup.object()
            })}
            onSubmit={async (data) => {
              query.set('name_filter', data.name);
              query.set('order_filter', data.order);
              query.set('active_filter', data.active ? data.active.value : "");
              history.push(`?${query.toString()}`);
            }}
            onReset={(data, actions) => {
              actions.setValues({
                name: '',
                order:'',
                active:'1'
              });
              query.set('name_filter', '');
              query.set('order_filter', '');
              query.set('active_filter', '');
              history.push(`?${query.toString()}`);
            }}
          >
            {({
              errors,
              handleBlur,
              handleChange,
              handleReset,
              isSubmitting,
              setFieldValue,
              touched,
              values
            }) => (
              <Form className={classes.root} noValidate autoComplete="off">
                <Grid container>
                  <Grid xs={12} md={4} className="p-2" item>
                    <TextField
                      error={Boolean(touched.name && errors.name)}
                      helperText={touched.name && errors.name}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      value={values.name}
                      fullWidth
                      label="Nombre"
                      name="name"
                      variant="outlined"
                      type="text"
                    />
                  </Grid>
                  <Grid xs={12} md={4} className="p-2" item>
                    <TextField
                      error={Boolean(touched.order && errors.order)}
                      helperText={touched.order && errors.order}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      value={values.order}
                      fullWidth
                      label="Orden"
                      name="order"
                      variant="outlined"
                      type="number"
                    />
                  </Grid>
                  <Grid item xs={12} md={4} className="p-2">
                      <FormControl fullWidth variant="outlined" className={classes.formControl}>
                        <SelectField
                          placeholder="Seleccione un estado..."
                          name="active"
                          getOptions={getEstadoOptions}
                          label="Estado"
                          setFieldValue={(value) => {
                            setFieldValue('active', value);
                          }}
                          value={values.active}
                        />
                      </FormControl>
                  </Grid>
                  <Grid item xs={12} className="pt-2 pl-2 text-right">
                    <Button
                      className={classes.importButton}
                      onClick={handleReset}
                      type="button"
                    >
                      Limpiar
                    </Button>
                    <Button
                      color="primary"
                      variant="contained"
                      disabled={isSubmitting}
                      type="submit"
                    >
                      Buscar
                    </Button>
                  </Grid>
                </Grid>
              </Form>
            )}
          </Formik>
        </CardContent>
      </Card>
    </Box>
  );
};

export default BarraBusquedaHeaders;
